import * as React from 'react';

import { Button } from '@cian/ui-kit';
import { ComplainFormWidget } from '@cian/complain-widget';

import { ClickOutside } from '../ClickOutside';

import { IconWarning } from './icons';

import * as styles from './Complaint.css';
import { trackComplaintClick } from './tracking';
import { ISendComplaintsParameters, ISendFeedbackParameters } from '../../actions/complain';
import { IComplaint } from '../../types/complain';

export interface IComplaintProps {
  userEmail: string;
  fullUrl: string;
  offerId: number;
  regionId?: number | null;
  complaints?: IComplaint[];
  isLoading: boolean;
  isSubmitted: boolean;
  getUserFeedback: boolean;
  complaintId?: number;
  isVisible: boolean;

  getComplaints(): void;
  sendComplaint({ offerId, complaintId, message }: ISendComplaintsParameters): void;
  sendFeedback({ email, complaintId }: ISendFeedbackParameters): void;
  changeVisibility(isVisible: boolean): void;
}

export class Complaint extends React.Component<IComplaintProps> {
  public static defaultProps = {
    complaints: [],
    isLoading: true,
    isSubmitted: false,
    getUserFeedback: false,
    complaintId: undefined,
    isVisible: false,
  };

  public render() {
    const {
      offerId,
      fullUrl,
      userEmail,
      regionId,
      isVisible,
      getComplaints,
      sendComplaint,
      sendFeedback,
      complaintId,
      complaints,
      getUserFeedback,
      isLoading,
      isSubmitted,
    } = this.props;

    return (
      <ClickOutside onOutside={this.onClose}>
        <div className={styles['container']}>
          <Button
            size="XS"
            beforeIcon={<IconWarning />}
            type="button"
            theme="fill_secondary"
            onClick={this.handleComplaintClick}
            title="Пожаловаться"
          />
          {isVisible && (
            <div className={styles['complaint_content']}>
              <ComplainFormWidget
                complaintId={complaintId}
                complaints={complaints}
                getUserFeedback={getUserFeedback}
                isLoading={isLoading}
                isSubmitted={isSubmitted}
                userEmail={userEmail}
                onClose={this.onClose}
                fullUrl={fullUrl}
                //@ts-ignore
                regionId={regionId}
                sendComplaintFeedback={sendFeedback}
                sendComplaint={sendComplaint}
                getComplaints={getComplaints}
                offerId={offerId}
              />
            </div>
          )}
        </div>
      </ClickOutside>
    );
  }

  private onClose = () => {
    if (this.props.isVisible) {
      this.props.changeVisibility(false);
    }
  };

  private handleComplaintClick = () => {
    this.props.changeVisibility(true);
    trackComplaintClick();
  };
}
